import { makeVar } from '@apollo/client/cache'

export enum INTERNAL_DEAL_STATUS {
  'CLOSED_UNLOCKED' = 'CLOSED_UNLOCKED', // this is set by as internal flag
  'LOCKED' = 'LOCKED',
}

export const dealStatusVar = makeVar<INTERNAL_DEAL_STATUS | null>(null)

export const setDealStatus = (dealStatusValue: INTERNAL_DEAL_STATUS) =>
  dealStatusVar(dealStatusValue)

export const getDealStatus = () => dealStatusVar()

export const dealCancelledVar = makeVar<boolean>(false)

export const setDealCancelled = (dealCancelledValue: boolean) =>
  dealCancelledVar(dealCancelledValue)

export const getDealCancelled = () => dealCancelledVar()

export const isDealLockedVar = makeVar<boolean>(false)

export const setIsDealLocked = (isDealLockedValue: boolean) => isDealLockedVar(isDealLockedValue)

export const getIsDealLocked = () => isDealLockedVar()
